import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const AnalysisCreditsDisplay = ({ creditsRemaining, userTier, onUpgrade }) => {
  if (userTier === 'premium') {
    const scansLeft = typeof creditsRemaining === 'number' ? creditsRemaining : 0;

    return (
      <div className="bg-accent/10 border border-accent/20 rounded-lg p-4">
        <div className="flex items-center space-x-3">
          <div className="w-10 h-10 bg-accent rounded-lg flex items-center justify-center">
            <Icon name="Crown" size={20} className="text-accent-foreground" />
          </div>
          <div className="flex-1">
            <h3 className="text-sm font-semibold text-foreground">Premium Member</h3>
            <p className="text-xs text-muted-foreground">
              {scansLeft > 0 ? 'Premium scans remaining' : 'No premium scans left'}
            </p>
          </div>
          <div className="text-right">
            <div className={`text-lg font-bold ${scansLeft > 0 ? 'text-accent' : 'text-warning'}`}>
              {scansLeft}
            </div>
            <div className="text-xs text-muted-foreground">Scans left</div>
            {scansLeft === 0 && (
              <button
                onClick={onUpgrade}
                className="mt-1 text-[11px] text-primary underline"
              >
                Buy more
              </button>
            )}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      {/* Credits Display */}
      <div className={`border rounded-lg p-4 ${
        creditsRemaining > 0 
          ? 'bg-card border-border' :'bg-warning/10 border-warning/20'
      }`}>
        <div className="flex items-center space-x-3">
          <div className={`w-10 h-10 rounded-lg flex items-center justify-center ${
            creditsRemaining > 0 
              ? 'bg-primary text-primary-foreground' 
              : 'bg-warning text-warning-foreground'
          }`}>
            <Icon name={creditsRemaining > 0 ? "Zap" : "AlertTriangle"} size={20} />
          </div>
          <div className="flex-1">
            <h3 className="text-sm font-semibold text-foreground">Free Plan</h3>
            <p className="text-xs text-muted-foreground">
              {creditsRemaining > 0 
                ? `${creditsRemaining} analysis${creditsRemaining === 1 ? '' : 'es'} remaining`
                : 'No analyses remaining'
              }
            </p>
          </div>
          <div className="text-right">
            <div className={`text-lg font-bold ${
              creditsRemaining > 0 ? 'text-primary' : 'text-warning'
            }`}>
              {creditsRemaining}
            </div>
            <div className="text-xs text-muted-foreground">Credits</div>
          </div>
        </div>
      </div>

      {/* Upgrade Prompt */}
      {creditsRemaining === 0 && (
        <div className="bg-primary/5 border border-primary/20 rounded-lg p-4">
          <div className="text-center space-y-3">
            <Icon name="Crown" size={32} className="text-primary mx-auto" />
            <div>
              <h3 className="text-sm font-semibold text-foreground">Upgrade to Premium</h3>
              <p className="text-xs text-muted-foreground mt-1">
                Get unlimited analyses and advanced features
              </p>
            </div>
            <div className="space-y-2">
              <div className="flex items-center justify-center space-x-4 text-xs text-muted-foreground">
                <div className="flex items-center space-x-1">
                  <Icon name="Check" size={12} className="text-success" />
                  <span>Unlimited analyses</span>
                </div>
                <div className="flex items-center space-x-1">
                  <Icon name="Check" size={12} className="text-success" />
                  <span>Learning paths</span>
                </div>
              </div>
              <Button variant="default" size="sm" onClick={onUpgrade} className="w-full">
                <Icon name="Crown" size={16} className="mr-2" />
                Upgrade Now - ₹999/month
              </Button>
            </div>
          </div>
        </div>
      )}

      {/* Low Credits Warning */}
      {creditsRemaining === 1 && (
        <div className="bg-warning/10 border border-warning/20 rounded-lg p-3">
          <div className="flex items-center space-x-2">
            <Icon name="AlertTriangle" size={16} className="text-warning" />
            <div className="flex-1">
              <p className="text-xs font-medium text-foreground">Last free analysis!</p>
              <p className="text-xs text-muted-foreground">
                Consider upgrading for unlimited access
              </p>
            </div>
            <Button variant="outline" size="xs" onClick={onUpgrade}>
              Upgrade
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};

export default AnalysisCreditsDisplay;